
import Component from "vue-class-component";
import Vue from "vue";
import { TruckModule, SystemModule } from "@/store/modules";
import { getModule } from "vuex-module-decorators";
import Select from "@/components/form/Select.vue";
import { DriverListItemResource } from "../../models/api/drivers/get";
import { EditDriverModel } from "@/models/ui/editDriver";
import { REGEX_EMAIL_VALIDATE, REGEX_PHONE_VALIDATE, REGEX_PHONE_REPLACE } from "../../consts";

const truckModuleState = getModule(TruckModule);
const systemModuleState = getModule(SystemModule);

import { formatDateWithTime } from "@/utils";
import notifications from "../../lib/notifications";
@Component({
  components: {
    Select
  }
})
export default class ImportTrucks extends Vue {
  includeInactive: boolean = false;
  facilityCode: string = null;
  drivers: DriverListItemResource[] = null;
  loading: boolean = false;
  editDriverModel: EditDriverModel = null;

  

  async created() {
    if (systemModuleState.facilities && systemModuleState.facilities.length > 1) {
      this.facilityCode = systemModuleState.facilities[1].facilityCode;
    }
    await this.loadDrivers();
  }

  async loadDrivers() {
    this.loading = true;
    this.drivers = await truckModuleState.getDrivers({
      facilityCode: this.facilityCode,
      includeInactive: this.includeInactive
    });
    this.loading = false;
  }

  format(dateToFormat) {
    return formatDateWithTime(dateToFormat);
  }

  driverNameState() {
    return this.editDriverModel.name ? null : false;
  }

  facilityState() {
    return this.editDriverModel.facilityCode ? null : false;
  }

  phoneState() {
    if(!this.editDriverModel.phoneNumber) return null;
    var regex = new RegExp(REGEX_PHONE_VALIDATE);
    return regex.test(this.editDriverModel.phoneNumber) ? null : false;
  }

  formatPhone(value) {
    if(!value) return null;
    const x = value.replace(/\D/g, '').match(REGEX_PHONE_REPLACE);
    return !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
  }

  emailState() {
    if(!this.editDriverModel.emailAddress) return null;
    var regex = new RegExp(REGEX_EMAIL_VALIDATE);
    return regex.test(this.editDriverModel.emailAddress) ? null : false;
  }

  validateForm() {
    if(this.driverNameState() === false) return false;
    if(!this.editDriverModel.facilityCode) return false;
    if(this.phoneState() === false) return false;
    if(this.emailState() === false) return false;
    return true;
  }

  goBack() {
    this.$router.back();
  }

  async saveDriver() {
    if(!this.validateForm()) return;

    try {
      if(!this.isCDSOwnedFacility(this.editDriverModel.facilityCode)) {
        this.$set(this.editDriverModel, 'carrier', null);
      }
      this.editDriverModel.saving = true;
      if (this.editDriverModel.isNew) {
        await truckModuleState.createDriver(this.editDriverModel.toCreateDriverRequest());
      } else {
        await truckModuleState.updateDriver(this.editDriverModel.toUpdateDriverRequest());
      }
      notifications.success("Driver Saved", "Successfully saved driver");
      await this.loadDrivers();
      this.closeEditDriverModal();
    } catch (ex) {
      notifications.error("Save Driver", "Failed to save driver", ex);
      this.editDriverModel.saving = false;
    }
  }

  closeEditDriverModal() {
    this.editDriverModel.visible = false;
    this.editDriverModel = null;
  }

  isCDSOwnedFacility(facilityCode: string) {
    return systemModuleState ? systemModuleState.cdsFacilities.indexOf(facilityCode) > -1 : false;
  }

  async editDriver(item: DriverListItemResource = null) {
    this.editDriverModel = new EditDriverModel();
    this.editDriverModel.visible = true;

    if (item) {
      const driver = await truckModuleState.getDriver(item.id);
      this.editDriverModel.loading = false;
      this.$set(this.editDriverModel, 'id', driver.id);
      this.$set(this.editDriverModel, 'name', driver.driverName);
      this.$set(this.editDriverModel, 'facilityCode', driver.facilityCode);
      this.$set(this.editDriverModel, 'carrier', driver.carrier);
      this.$set(this.editDriverModel, 'emailAddress', driver.emailAddress);
      this.$set(this.editDriverModel, 'phoneNumber', this.formatPhone(driver.phoneNumber));
      this.$set(this.editDriverModel, 'isActive', driver.isActive);
    } else {
      this.editDriverModel.showForNewDriver(this.facilityCode);
    }
  }
}
